import { Injectable } from "@angular/core";
import { MessageService } from "src/services/message/message.service";
import { PaymentMethod, StripeCardElement, StripeCardNumberElement } from "@stripe/stripe-js";
import { StripeService } from "src/services/stripe/stripe.service";
import { environment } from "@environments/environment";
import { HttpService } from "src/services/http/http.service";
import type { Stripe } from "stripe";
import { DataPage } from "src/services/utils/api.utils";
import { DeletePaymentMethodRequestBody } from "../../shared/local-api.types";

@Injectable({
  providedIn: "root",
})
export class CardService {
  constructor(
    private readonly httpService: HttpService,
    private readonly messageService: MessageService,
    private readonly stripeService: StripeService,
  ) {}

  public async saveCard(
    card: StripeCardElement | StripeCardNumberElement,
    clientSecret: string,
  ): Promise<string | PaymentMethod | null> {
    const response = await this.stripeService.stripeClient.confirmCardSetup(clientSecret, {
      payment_method: { card: card },
    });

    if (response.error) {
      throw new Error(response.error.message);
    }

    await this.messageService.presentSuccessToast("Success! Card added to your wallet");

    return response.setupIntent.payment_method;
  }

  public async getWallet(): Promise<DataPage<Stripe.PaymentMethod>> {
    return this.httpService.sendGetRequest<DataPage<Stripe.PaymentMethod>>(environment.endpoints.getWallet);
  }

  public async deleteCard(cardId: string): Promise<unknown> {
    return this.httpService.sendPostRequest<DeletePaymentMethodRequestBody, unknown>(
      environment.endpoints.deletePaymentMethod,
      { cardId },
    );
  }
}
